import { onSignalREvent } from '../../signalRBus'
import { APIS, LOADERS } from 'src/config/constants'
import { useAttStore } from 'src/stores'
import { router } from 'src/router'
import { useLoader } from '../../../hooks/useLoader'
import { useAuthStore } from 'src/common/store'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'

function refreshAttendance() {
  const route = router.currentRoute.value
  if (route.path !== '/') return
  const attStore = useAttStore()
  const { useFetchLoader: fetchAttendances } = useLoader(LOADERS.attendance, {
    uri: APIS.attendance,
  })
  void fetchAttendances().then((result) => {
    attStore.setAttendancesAndNodes(result)
  })
}

function centerIdMatches(text: string) {
  const authStore = useAuthStore()
  const eventCenterId = text.split('_')[1]
  const localCenterId = authStore.currentCenterId
  if (!localCenterId) {
    return false
  }

  return localCenterId === eventCenterId
}

onSignalREvent(
  SIGNAL_R_SCOPES.system,
  SIGNAL_R_MESSAGES.getAttendance,
  (text) => {
    if (!centerIdMatches(text)) {
      return
    }
    refreshAttendance()
  },
  {
    onReconnect: refreshAttendance,
  },
)
